var _style, _path, _defs, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGriffinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.62;fill:url(#SVGID_00000057866513114789401000000014860818342599085220_);enable-background:new    ;}\r\n\t.st2{opacity:0.56;fill:url(#SVGID_00000086661554315348617970000017166008410026901920_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_00000101817049118306672000000016024666002323357868_);}\r\n\t.st4{opacity:0.62;fill:url(#SVGID_00000010272499124208645440000014981570763493403809_);enable-background:new    ;}\r\n\t.st5{opacity:0.47;fill:url(#SVGID_00000162323813012666128110000007569700031720454590_);enable-background:new    ;}\r\n\t.st6{fill:url(#SVGID_00000165956851824213188750000001212813002617447816_);}\r\n\t.st7{opacity:0.62;fill:url(#SVGID_00000177459458229741692030000011165695146509069746_);enable-background:new    ;}\r\n\t.st8{opacity:0.39;fill:url(#SVGID_00000116917935812475002050000000735705061848608672_);enable-background:new    ;}\r\n\t.st9{fill:url(#SVGID_00000168100057318515588670000005598888195623192735_);}\r\n\t.st10{opacity:0.62;fill:url(#SVGID_00000008851058049100055100000009798113029917824907_);enable-background:new    ;}\r\n\t.st11{opacity:0.56;fill:url(#SVGID_00000034074797004067919700000013413579746596616320_);enable-background:new    ;}\r\n\t.st12{fill:url(#SVGID_00000016069686611488595740000001744806225460560275_);}\r\n\t.st13{fill:url(#SVGID_00000183241851340604163680000012297810548803388572_);}\r\n\t.st14{opacity:0.35;fill:url(#SVGID_00000035498993001374525050000002204253120529593777_);enable-background:new    ;}\r\n\t.st15{fill:url(#SVGID_00000023979476395805971330000010930189940607024809_);}\r\n\t.st16{fill:url(#SVGID_00000130619084415010807700000003213759603517548437_);}\r\n\t.st17{fill:url(#SVGID_00000088097511791732472220000005066746176506307970_);filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st18{mask:url(#mask_00000026160442408994705330000012667343570071154567_);}\r\n\t.st19{opacity:0.68;fill:url(#SVGID_00000061446971255834130610000004589340807522145977_);enable-background:new    ;}\r\n\t.st20{fill:url(#SVGID_00000043457044736778868010000006407673559097566376_);}\r\n\t.st21{fill:url(#SVGID_00000103258904690622558520000007008044889811699645_);}\r\n\t.st22{fill:url(#SVGID_00000140706217846865348700000008597815705794013104_);}\r\n\t.st23{fill:url(#SVGID_00000162342317386578203810000014300653194018098570_);}\r\n\t.st24{fill:url(#SVGID_00000035511244820208120610000003877489262459830400_);}\r\n\t.st25{fill:url(#SVGID_00000111187233015627366850000006542136001406316215_);}\r\n\t.st26{fill:#1A2335;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.4061,
    y1: 312.4663,
    x2: 745.4058,
    y2: 245.3438,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#FAB32B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#F9AE2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F6A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F28C65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#EE7191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#EC66A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#7F4796"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.3,299.26c-18.5-10.16-36.33-13.33-58.55-10.55c-0.13,0.02-0.47,0.06-0.73,0.09 c33.63,3.23,60.9,34.24,61.07,68.72c0,1.5-0.12,3.79-0.23,5.51c-0.04,0.65,0.46,1.22,1.11,1.26c0.26,0.02,0.51-0.05,0.73-0.19 c4.82-3.23,9.09-7.27,12.26-12.13c7.14-10.93,10.04-22.83,9.47-31.99C741.13,314.24,733.47,306.5,720.3,299.26L720.3,299.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183221887644697145150000015227083390873998758_",
    gradientUnits: "userSpaceOnUse",
    x1: 699.9103,
    y1: 277.1034,
    x2: 743.5784,
    y2: 320.3124,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#F2EBF6",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#CCB6D9",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#8663A7",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#4D2C87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000183221887644697145150000015227083390873998758_)",
      enableBackground: "new"
    },
    d: " M720.3,299.26c-18.5-10.16-36.33-13.33-58.55-10.55c-0.13,0.02-0.47,0.06-0.73,0.09c33.63,3.23,60.9,34.24,61.07,68.72 c0,1.5-0.12,3.79-0.23,5.51c-0.04,0.65,0.46,1.22,1.11,1.26c0.26,0.02,0.51-0.05,0.73-0.19c4.82-3.23,9.09-7.27,12.26-12.13 c7.14-10.93,10.04-22.83,9.47-31.99C741.13,314.24,733.47,306.5,720.3,299.26L720.3,299.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060711901232697310200000005555293500372437179_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.0007,
    y1: 322.7399,
    x2: 751.8652,
    y2: 239.8505,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FAD7DE",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F0869D",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#EA4E6C",
      stopOpacity: 0.78
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#E73351",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#E72C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "url(#SVGID_00000060711901232697310200000005555293500372437179_)",
      enableBackground: "new"
    },
    d: " M720.3,299.26c-18.5-10.16-36.33-13.33-58.55-10.55c-0.13,0.02-0.47,0.06-0.73,0.09c33.63,3.23,60.9,34.24,61.07,68.72 c0,1.5-0.12,3.79-0.23,5.51c-0.04,0.65,0.46,1.22,1.11,1.26c0.26,0.02,0.51-0.05,0.73-0.19c4.82-3.23,9.09-7.27,12.26-12.13 c7.14-10.93,10.04-22.83,9.47-31.99C741.13,314.24,733.47,306.5,720.3,299.26L720.3,299.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065794683319471433750000012758162918538830241_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.6578,
    y1: 295.7962,
    x2: 735.8592,
    y2: 215.6476,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7A71F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F7A621"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F6A12B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#F4993C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#F28F51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#F08169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#EE728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#EC66A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#7F4796"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065794683319471433750000012758162918538830241_)"
    },
    d: "M722.04,354.62 c-0.27,0.36-0.47,0.71-0.75,1.07c-8.05,10.16-19.58,16.97-32.36,19.11c-2.67,0.45-5.38,0.57-8.08,0.36 c-0.32-0.03-0.65-0.06-0.97-0.09c-0.55-0.06-0.95-0.56-0.89-1.11c0.02-0.22,0.12-0.43,0.28-0.59c0.97-1,1.9-2.05,2.79-3.15 c1.81-2.22,3.44-4.58,4.87-7.06c12.61-21.92,7.88-50.38-12.34-66.89c-4.15-3.39-8.55-5.32-12.45-7.35 c12.86,1.45,24.73,7,34.49,15.18C711.1,316.21,721.18,335.18,722.04,354.62L722.04,354.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031189381430158856650000016827222847423255732_",
    gradientUnits: "userSpaceOnUse",
    x1: 664.1451,
    y1: 261.3315,
    x2: 750.269,
    y2: 286.49,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F4EFF7",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D6C3E0",
      stopOpacity: 0.24
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#A47AB4",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#5D2481",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#4B2772"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000031189381430158856650000016827222847423255732_)",
      enableBackground: "new"
    },
    d: " M722.04,354.62c-0.27,0.36-0.47,0.71-0.75,1.07c-8.05,10.16-19.58,16.97-32.36,19.11c-2.67,0.45-5.38,0.57-8.08,0.36 c-0.32-0.03-0.65-0.06-0.97-0.09c-0.55-0.06-0.95-0.56-0.89-1.11c0.02-0.22,0.12-0.43,0.28-0.59c0.97-1,1.9-2.05,2.79-3.15 c1.81-2.22,3.44-4.58,4.87-7.06c12.61-21.92,7.88-50.38-12.34-66.89c-4.15-3.39-8.55-5.32-12.45-7.35 c12.86,1.45,24.73,7,34.49,15.18C711.1,316.21,721.18,335.18,722.04,354.62L722.04,354.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097464232297971911560000009118057214492122512_",
    gradientUnits: "userSpaceOnUse",
    x1: 667.0042,
    y1: 264.5852,
    x2: 733.541,
    y2: 265.0036,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#FCE3E9",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F5AEBD",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#EF8097",
      stopOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#EB5D79",
      stopOpacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#E94462",
      stopOpacity: 0.84
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#E73653",
      stopOpacity: 0.93
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#E72E4A",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#E72C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.47,
      fill: "url(#SVGID_00000097464232297971911560000009118057214492122512_)",
      enableBackground: "new"
    },
    d: " M722.04,354.62c-0.27,0.36-0.47,0.71-0.75,1.07c-8.05,10.16-19.58,16.97-32.36,19.11c-2.67,0.45-5.38,0.57-8.08,0.36 c-0.32-0.03-0.65-0.06-0.97-0.09c-0.55-0.06-0.95-0.56-0.89-1.11c0.02-0.22,0.12-0.43,0.28-0.59c0.97-1,1.9-2.05,2.79-3.15 c1.81-2.22,3.44-4.58,4.87-7.06c12.61-21.92,7.88-50.38-12.34-66.89c-4.15-3.39-8.55-5.32-12.45-7.35 c12.86,1.45,24.73,7,34.49,15.18C711.1,316.21,721.18,335.18,722.04,354.62L722.04,354.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065779723545870131640000007721926262978708122_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.7083,
    y1: 293.9794,
    x2: 697.5842,
    y2: 214.2879,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#F7BC17"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F6A241"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#EC66A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#A74F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#7F4796"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065779723545870131640000007721926262978708122_)"
    },
    d: "M686.9,363.15 c-2.64,1.65-5.49,2.92-8.49,3.77c-10.74,3.11-25.47-0.74-34.48-5.85c-0.82-0.57-1.61-1.17-2.38-1.81 c-0.48-0.4-0.54-1.11-0.14-1.58c0.16-0.19,0.38-0.33,0.63-0.38c0.8-0.18,1.59-0.38,2.38-0.61c21.13-6.1,33.31-28.17,27.21-49.3 c-0.01-0.03-0.01-0.05-0.02-0.08c-1.96-6.77-5.44-13.73-10.11-18.48c0.16,0.02,0.47,0.05,0.63,0.08c3.27,1.69,6.76,3.25,10.3,5.73 c0.7,0.49,1.4,1,2.09,1.57C694.75,312.73,699.53,341.23,686.9,363.15L686.9,363.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010290837350239032980000012315117372130650810_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.778,
    y1: 284.009,
    x2: 706.923,
    y2: 226.5107,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#F8F5FA",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#E4D7EA",
      stopOpacity: 0.16
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#C2A6D0",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#9362A6",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#522678",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#4B2772"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000010290837350239032980000012315117372130650810_)",
      enableBackground: "new"
    },
    d: " M686.9,363.15c-2.64,1.65-5.49,2.92-8.49,3.77c-10.74,3.11-25.47-0.74-34.48-5.85c-0.82-0.57-1.61-1.17-2.38-1.81 c-0.48-0.4-0.54-1.11-0.14-1.58c0.16-0.19,0.38-0.33,0.63-0.38c0.8-0.18,1.59-0.38,2.38-0.61c21.13-6.1,33.31-28.17,27.21-49.3 c-0.01-0.03-0.01-0.05-0.02-0.08c-1.96-6.77-5.44-13.73-10.11-18.48c0.16,0.02,0.47,0.05,0.63,0.08c3.27,1.69,6.76,3.25,10.3,5.73 c0.7,0.49,1.4,1,2.09,1.57C694.75,312.73,699.53,341.23,686.9,363.15L686.9,363.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178922108806253008010000002489507882260428165_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.5261,
    y1: 264.1342,
    x2: 692.6897,
    y2: 271.8885,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#FEF2F5",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F9D1D9",
      stopOpacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#F39CAF",
      stopOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#EB5976",
      stopOpacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E72C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "url(#SVGID_00000178922108806253008010000002489507882260428165_)",
      enableBackground: "new"
    },
    d: " M686.9,363.15c-2.64,1.65-5.49,2.92-8.49,3.77c-10.74,3.11-25.47-0.74-34.48-5.85c-0.82-0.57-1.61-1.17-2.38-1.81 c-0.48-0.4-0.54-1.11-0.14-1.58c0.16-0.19,0.38-0.33,0.63-0.38c0.8-0.18,1.59-0.38,2.38-0.61c21.13-6.1,33.31-28.17,27.21-49.3 c-0.01-0.03-0.01-0.05-0.02-0.08c-1.96-6.77-5.44-13.73-10.11-18.48c0.16,0.02,0.47,0.05,0.63,0.08c3.27,1.69,6.76,3.25,10.3,5.73 c0.7,0.49,1.4,1,2.09,1.57C694.75,312.73,699.53,341.23,686.9,363.15L686.9,363.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031168913812655983640000016714580465943669668_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.2816,
    y1: 294.4479,
    x2: 663.7218,
    y2: 229.1968,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#F6A34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EF7A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#EB579A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#D95399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#944A96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#824896"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031168913812655983640000016714580465943669668_)"
    },
    d: "M654.17,352.39 c-0.29,0-0.58,0.01-0.87,0.01c-10.97,0.05-19.33-4.39-24.22-9.22c-1.71-1.69-3.17-3.6-4.35-5.7c-0.29-0.51-0.12-1.16,0.39-1.45 c0.21-0.12,0.45-0.17,0.69-0.13c1.48,0.22,2.97,0.33,4.46,0.34h0.43c4.79,0.08,9.53-0.96,13.85-3.02c0.07-0.03,0.15-0.07,0.22-0.1 c15.76-7.34,23.26-25.53,17.27-41.85c-0.31-0.84-0.65-1.67-1.02-2.48c0.16,0,0.31,0.01,0.48,0.04c4.67,4.75,8.13,11.71,10.1,18.48 C676.6,324.55,669.46,343,654.17,352.39L654.17,352.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061449611094092297050000000673747637380350097_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.9319,
    y1: 281.8603,
    x2: 678.4472,
    y2: 251.8551,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#E7DBEC",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#A880B8",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#4B2772"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000061449611094092297050000000673747637380350097_)",
      enableBackground: "new"
    },
    d: " M654.17,352.39c-0.29,0-0.58,0.01-0.87,0.01c-10.97,0.05-19.33-4.39-24.22-9.22c-1.71-1.69-3.17-3.6-4.35-5.7 c-0.29-0.51-0.12-1.16,0.39-1.45c0.21-0.12,0.45-0.17,0.69-0.13c1.48,0.22,2.97,0.33,4.46,0.34h0.43 c4.79,0.08,9.53-0.96,13.85-3.02c0.07-0.03,0.15-0.07,0.22-0.1c15.76-7.34,23.26-25.53,17.27-41.85 c-0.31-0.84-0.65-1.67-1.02-2.48c0.16,0,0.31,0.01,0.48,0.04c4.67,4.75,8.13,11.71,10.1,18.48 C676.6,324.55,669.46,343,654.17,352.39L654.17,352.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178181995254885661020000001932029349002312373_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.5471,
    y1: 285.5005,
    x2: 675.0987,
    y2: 268.2398,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FCE1E7",
      stopOpacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E72C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "url(#SVGID_00000178181995254885661020000001932029349002312373_)",
      enableBackground: "new"
    },
    d: " M654.17,352.39c-0.29,0-0.58,0.01-0.87,0.01c-10.97,0.05-19.33-4.39-24.22-9.22c-1.71-1.69-3.17-3.6-4.35-5.7 c-0.29-0.51-0.12-1.16,0.39-1.45c0.21-0.12,0.45-0.17,0.69-0.13c1.48,0.22,2.97,0.33,4.46,0.34h0.43 c4.79,0.08,9.53-0.96,13.85-3.02c0.07-0.03,0.15-0.07,0.22-0.1c15.76-7.34,23.26-25.53,17.27-41.85 c-0.31-0.84-0.65-1.67-1.02-2.48c0.16,0,0.31,0.01,0.48,0.04c4.67,4.75,8.13,11.71,10.1,18.48 C676.6,324.55,669.46,343,654.17,352.39L654.17,352.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054963997435432355190000011510735773690281384_",
    gradientUnits: "userSpaceOnUse",
    x1: 681.7608,
    y1: 372.0138,
    x2: 699.1378,
    y2: 348.8206,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#FFCE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#FDC53C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F8AE58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F1887E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC66A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054963997435432355190000011510735773690281384_)"
    },
    d: "M706.87,243.53 c-10.03-3.27-20.7-4.29-30.9-2.7c9.33-5.24,14.4-15.46,16.16-19.66c0.35-0.86,1.33-1.28,2.19-0.93c0.11,0.04,0.22,0.1,0.32,0.17 C702.26,225.55,706.36,234.4,706.87,243.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049214650978238292820000005028251557546417792_",
    gradientUnits: "userSpaceOnUse",
    x1: 701.0806,
    y1: 368.1843,
    x2: 734.0795,
    y2: 323.9774,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#FCC924"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCC32C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#F9B342"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#F49963"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#EE778F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#EC66A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049214650978238292820000005028251557546417792_)"
    },
    d: "M725.46,252.79 c-2.85-1.99-5.85-3.77-8.97-5.32c-9.47-4.71-19.95-7.28-30.33-7.37c0.71-0.08,4.49-0.48,5.91-0.82 c9.12-2.15,20.14-9.98,24.28-17.69c0.38-0.73,1.27-1.01,1.99-0.63c0.13,0.07,0.25,0.15,0.35,0.25 C727.06,229.15,728.91,241.92,725.46,252.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035491975054096817700000009214841521002355375_",
    gradientUnits: "userSpaceOnUse",
    x1: 700.8315,
    y1: 368.0241,
    x2: 723.3452,
    y2: 330.3375,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#FCC924"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#F9B341"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#EF7D83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#EC66A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "url(#SVGID_00000035491975054096817700000009214841521002355375_)",
      enableBackground: "new"
    },
    d: " M716.49,247.46c0.38-0.59,0.71-1.22,0.98-1.86c4.9-11.6,1.39-21.79,0.1-24.82c-0.52,0.03-0.99,0.33-1.23,0.8 c-4.13,7.71-15.16,15.54-24.28,17.69c-1.43,0.33-5.2,0.74-5.91,0.82C696.54,240.19,707.03,242.77,716.49,247.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057118435440824700490000007086406391568611772_",
    gradientUnits: "userSpaceOnUse",
    x1: 625.5168,
    y1: 377.5673,
    x2: 781.9163,
    y2: 241.6121,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#F9E930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#F9E930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FCE826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FDD739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FAB955"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#F2917B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#EC66A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#734B98"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057118435440824700490000007086406391568611772_)"
    },
    d: "M751.3,326.01 c-0.15,0.55-0.71,0.88-1.26,0.73c-0.28-0.08-0.52-0.27-0.66-0.53c-2.52-4.95-10.03-16.45-29.13-26.94 c-18.69-10.27-36.68-13.39-59.23-10.46c-1.02-1.93-5.08-8.08-7.05-10.19c1.98-2.79,27.8-28.27,69.28-10.7 C743.81,276.61,757.09,304.15,751.3,326.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161602860480962702630000006067414556489324932_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.3487,
    y1: 352.2166,
    x2: 780.6201,
    y2: 261.4254,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#FAB829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#F9B230"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#F59F47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F0826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#EC5F9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#EB5B9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#734B98"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161602860480962702630000006067414556489324932_)"
    },
    d: "M751.3,326.01 c-0.15,0.55-0.71,0.88-1.26,0.73c-0.28-0.08-0.52-0.27-0.66-0.53c-2.52-4.95-10.03-16.45-29.13-26.94 c-18.69-10.27-36.68-13.39-59.23-10.46c-1.02-1.93-5.08-8.08-7.05-10.19c1.98-2.79,27.8-28.27,69.28-10.7 C743.81,276.61,757.09,304.15,751.3,326.01z"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 653.98,
    y: 261.79,
    width: 98.69,
    height: 64.98
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 653.98,
    y: 261.79,
    width: 98.69,
    height: 64.98,
    id: "mask_00000026160442408994705330000012667343570071154567_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036238101651262018670000000781869192935721146_",
    gradientUnits: "userSpaceOnUse",
    x1: 749.5899,
    y1: 329.8899,
    x2: 697.2465,
    y2: 301.8826,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#D7D8D7",
      stopOpacity: 0.16
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010202"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036238101651262018670000000781869192935721146_)",
      filter: "url(#Adobe_OpacityMaskFilter)"
    },
    d: " M651.54,248.64h110.9v81.91h-110.9V248.64z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000102532189914782703190000005818594673063765439_",
    cx: 1678.7164,
    cy: 2283.854,
    r: 86.4138,
    gradientTransform: "matrix(0.6575 -0.7534 -0.6329 -0.5523 1023.2441 2869.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FFF9F9",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FEF1EF",
      stopOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#FCE5E2",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#FAD4D1",
      stopOpacity: 0.24
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F8C1BC",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F5AAA3",
      stopOpacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F29087",
      stopOpacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#EE7468",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#EA5545",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#EA5444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000102532189914782703190000005818594673063765439_)",
      enableBackground: "new"
    },
    d: " M751.3,326c-0.15,0.55-0.72,0.88-1.27,0.73c-0.28-0.08-0.52-0.27-0.65-0.53c-2.52-4.95-10.03-16.45-29.12-26.94 c-18.69-10.27-36.68-13.39-59.23-10.46c-1.02-1.93-5.08-8.08-7.05-10.19c1.98-2.79,27.8-28.27,69.28-10.7 C743.81,276.61,757.09,304.15,751.3,326z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079484645864739465470000010229349277020343698_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.8467,
    y1: 356.082,
    x2: 749.6053,
    y2: 277.1864,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#FCC924"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FBBB34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F3965C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#EC5F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#AE5199"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6529A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079484645864739465470000010229349277020343698_)"
    },
    d: "M747.98,280.59 c-7.32-18.16-23.18-31.2-41.11-37.05c-10.03-3.27-20.7-4.29-30.9-2.7c-15.13,2.36-29.2,10.49-38.54,25.57 c2.45,0.72,10.18,5.39,16.54,12.21c2.83,3.03,5.38,6.48,7.05,10.19c0.06-0.05,28.98-15.36,46.76-14.92 c12.54,0.32,25.56,3.21,37.68,8.43C748.19,283.51,748.67,282.16,747.98,280.59z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000083777035516694024640000010616734619385676435_",
    cx: 625.9279,
    cy: 365.9365,
    r: 133.0593,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#FCC924"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.29
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.16
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083777035516694024640000010616734619385676435_)"
    },
    d: "M739.18,279.84 c2.12,0.76,4.21,1.58,6.29,2.46c2.72,1.21,3.2-0.15,2.51-1.72c-17.5-43.38-83.67-57.6-110.54-14.19 c2.45,0.72,10.18,5.39,16.54,12.21c2.83,3.03,5.38,6.48,7.05,10.19c0.23-0.01,0.46-0.04,0.69-0.09 c22.23-2.77,40.05,0.39,58.54,10.55c19.1,10.49,26.61,22,29.13,26.94c0.26,0.51,0.88,0.71,1.39,0.45 c0.26-0.13,0.45-0.37,0.53-0.66C755.4,310.57,749.96,292.31,739.18,279.84L739.18,279.84z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000098916288098464812840000018432633906558133642_",
    cx: 640.9988,
    cy: 359.5102,
    r: 85.7975,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#FCC924"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#FCC924",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098916288098464812840000018432633906558133642_)"
    },
    d: "M739.18,279.84 c2.12,0.76,4.21,1.58,6.29,2.46c2.72,1.21,3.2-0.15,2.51-1.72c-17.5-43.38-83.67-57.6-110.54-14.19 c2.45,0.72,10.18,5.39,16.54,12.21c2.83,3.03,5.38,6.48,7.05,10.19c0.23-0.01,0.46-0.04,0.69-0.09 c22.23-2.77,40.05,0.39,58.54,10.55c19.09,10.49,26.6,21.99,29.12,26.94c0.26,0.51,0.88,0.71,1.39,0.45 c0.27-0.14,0.46-0.38,0.53-0.67C755.39,310.56,749.95,292.3,739.18,279.84L739.18,279.84z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164493925347679626950000001407962395895590288_",
    cx: 654.5862,
    cy: 328.3213,
    r: 24.9544,
    fx: 644.8514,
    fy: 328.3213,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164493925347679626950000001407962395895590288_)"
    },
    d: "M679.12,263.21 c-7.13,2.01-13.79,5.43-19.59,10.04c-2.52-5.54-0.06-12.07,5.48-14.59C670.18,256.32,676.29,258.29,679.12,263.21L679.12,263.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153663684089410183740000012049970765631983798_",
    gradientUnits: "userSpaceOnUse",
    x1: 621.6133,
    y1: 337.0263,
    x2: 656.3245,
    y2: 284.9604,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F9E930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#EF785C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#EC6069"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153663684089410183740000012049970765631983798_)"
    },
    d: "M653.98,278.61 c-8.03,10.11-17.66,13.57-19.12,14.05l-0.08,0.02l-0.07,0.02l-0.04,0.01c-2.16,0.66-4.17,1.77-5.88,3.24 c-0.85,0.74-2.14,0.65-2.88-0.2c-0.21-0.25-0.36-0.54-0.44-0.85c-1.44-5.83-1.22-18.34,7.64-25.68c1.21-1,4.17-2.78,4.33-2.82 C639.89,267.12,647.61,271.79,653.98,278.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123441549295720254980000007577804991646490301_",
    gradientUnits: "userSpaceOnUse",
    x1: 647.4994,
    y1: 328.654,
    x2: 648.4259,
    y2: 282.9206,
    gradientTransform: "matrix(1 0 0 -1 -0.0151 596.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F8AC0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F7A816"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#EE777C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#EC66A2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123441549295720254980000007577804991646490301_)"
    },
    d: "M661.03,288.8 c-9.77,3.34-18.81,1.6-26.17,3.86c1.46-0.48,11.09-3.94,19.12-14.05C656.81,281.64,659.36,285.09,661.03,288.8z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M67.32,306.87c0-38.95,30.68-66.72,74.3-66.72c12.95,0,27.08,2.41,35.01,6.01v24.32h-0.89l-30.33-21.71 c-1.57-0.54-4.83-0.89-7.93-0.89c-22.95,0-39.15,21.38-39.15,50.87c0,32.94,20.19,58.59,45.84,58.59 c1.74-0.03,3.47-0.21,5.18-0.54l-0.49-0.2v-54.7l-7.78-9.5v-0.89h45.35v0.89l-7.78,9.5v63.62h-0.89l-19.65-6.06 c-7.58,3.79-19.3,6.55-29.84,6.55C92.13,366,67.32,342.02,67.32,306.87z M207.4,290.17l-9.16-9.16v-0.7l32.6-8.61h1.72l1.22,18.46 h1.03c7.44-13.1,13.99-18.46,22.26-18.46c3.45,0,6.4,1.03,7.93,2.41v27.92h-0.89l-17.42-11.72c-0.52-0.11-1.05-0.16-1.58-0.15 c-3.59,0-8.77,3.45-10.49,7.58v56.53l9.11,8.28v0.89h-44.12v-0.89l7.78-8.27V290.17z M272.4,363.39v-0.69l7.78-8.47v-64.06 l-9.16-8.96v-0.89l34.66-8.62h1.72v82.58l7.78,8.47v0.69H272.4V363.39z M278.94,244.33c0-8.47,5.71-13.64,14.82-13.64 c9.11,0,14.82,5.17,14.82,13.64c0,8.27-5.66,13.44-14.82,13.44C284.61,257.78,278.94,252.61,278.94,244.33z M327.85,363.39v-0.89 l7.78-8.27v-70.12h-12.26v-0.69l12.41-10.69c3.79-25.01,19.15-42.05,37.92-42.05c4.68,0,10.2,1.03,12.41,2.27l-2.76,22.6h-0.89 l-24.67-10.88c-5.37,0.54-10,9.31-10,17.23c0,10.19,7.78,15.85,21.02,15.85h22.95c1.38-26.53,16.2-47.07,34.66-47.07 c4.33,0,9.5,1.03,11.92,2.27l-2.95,22.41h-0.89l-21.9-10.35c-5.02,0.49-8.96,7.93-8.96,16.05c0,11.02,7.24,16.73,21.22,16.73 h52.74l-1.38,9.87v66.94l7.78,8.12v0.69H441.1v-0.69l7.93-8.47v-70.14h-30.18v70.17l10.34,8.28v0.89h-45.51v-0.89l7.93-8.47 v-69.97h-28.8v70.17l10.34,8.28v0.89h-45.3L327.85,363.39z M447.84,244.33c0-8.47,5.66-13.64,14.82-13.64 c9.31,0,15.02,5.17,15.02,13.64c0,8.27-5.71,13.44-15.02,13.44C453.51,257.78,447.84,252.61,447.84,244.33z M531.75,354.28 l7.78,8.28v0.89h-42.79v-0.89l7.78-8.27v-64.08l-9.16-9.16v-0.89l32.6-8.47h1.72l1.22,16.2h1.18c9.45-10.88,19.65-16.2,31.02-16.2 c15.36,0,26.05,10,26.05,24.13v58.45l7.78,8.27v0.89H554v-0.89l7.93-8.81v-52.49c0-8.47-5.17-13.64-13.44-13.64 c-5.51,0-11.02,2.21-16.73,6.7L531.75,354.28L531.75,354.28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriffinLogo);
export default __webpack_public_path__ + "static/media/griffin_logo.83ea204a7f65db11520d9571d0699048.svg";
export { ForwardRef as ReactComponent };